export default __webpack_public_path__ + "static/media/main.71d166e3.png";